export const webhookEventsSelectors = {
  gridData: (state) => state.gridData,
  item: (state) => state.item,
  update: (state) => state.update,
}
